module.exports = __webpack_public_path__ + "static/media/main.c9af86e3.jpg";